import { Chessboard } from "react-chessboard-kit";
import { Chess } from 'chess.js';
import { useState } from "react"

export function Main() {
  const [chess, setChess] = useState(new Chess());
  const [theme, setTheme] = useState("default")
  const [orientation, setOrientation] = useState<"white" | "black">("white")
  const themeNames = [
    "default",
    "coral",
    "dusk",
    "marine",
    "wheat",
    "emerald",
    "sandcastle"
  ];

  return (
    <div className="flex flex-col items-center justify-center gap-3 text-white bg-background h-dvh">
      <h1 className="text-3xl font-semibold">
        React Chessboard Kit
      </h1>
      <p className="text-lg">
        A simple and easy to use chessboard component for React
      </p>

      <div className="flex gap-2">
        <a href="https://www.npmjs.com/package/react-chessboard-kit" target="_blank" rel="noopener noreferrer"
          className="text-blue-500 hover:underline"
        >
          NPM Package
        </a>


        <a href="https://github.com/eAntillon/react-chessboard-kit" target="_blank" rel="noopener noreferrer"
          className="text-blue-500 hover:underline"
        >
          Documentation
        </a>

      </div>

      <div className="flex flex-col items-start justify-center w-full max-w-screen-md gap-3 md:flex-row">
        <Chessboard boardPosition={chess.fen()}
          onMove={(move) => {
            setChess((prev) => {
              prev.move({ from: move.from, to: move.to, promotion: move.promotion })
              return new Chess(prev.fen())
            }
            )
          }}
          orientation={orientation} theme={theme}
        />
        <div className="w-2/3 text-sm bg-default">
          <h1 className="px-3 py-2 font-semibold capitalize bg-accent">
            Board props
          </h1>
          <div className="flex flex-col gap-3 p-3">
            <div className="flex flex-col gap-3">
              <p className="border-b border-accent">Board FEN:</p>
              <textarea
                disabled
                aria-disabled
                className="p-1 px-1.5 border rounded-sm resize-none bg-background border-accent focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500"
                value={chess.fen()}
              />
            </div>
            <div className="flex flex-col gap-3">
              <p className="border-b border-accent">Theme:</p>

              <select
                value={theme}
                onChange={(e) => setTheme(e.target.value)}
                className="p-1 px-1.5 border rounded-sm bg-background border-accent focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500" >
                {themeNames.map((theme) => (
                  <option key={theme} value={theme}>{theme}</option>
                ))}
              </select>
            </div>
            <div className="flex flex-col gap-3">
              <p className="border-b border-accent">
                Orientation:
              </p>
              <select
                value={orientation}
                onChange={(e) => setOrientation(e.target.value as "white" | "black")}
                className="p-1 px-1.5 border rounded-sm bg-background border-accent focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500" >
                <option value="white">White</option>
                <option value="black">Black</option>
              </select>
            </div>
            <div className="flex flex-col gap-3">
              <p className="border-b border-accent">
                Reset board:
              </p>
              <button
                onClick={() => setChess(new Chess())}
                className="p-1 px-1.5 border rounded-sm bg-background border-accent focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500" >
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}